export default __webpack_public_path__ + "static/media/pb-logo-mobile.b77e3c07.svg";